import React, { Component, Fragment } from "react"
import styles from "./styles.module.scss"
import { Button, RulesModal } from "../../components"
import { Redirect } from "react-router-dom"
import {
  isIOS,
  wechatShare,
  initSensors,
  trackEvent,
  login,
  getKey,
  removeWechatPostfix,
} from "../../utils"

class Home extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showRulesModal: false,
      loggedIn: false,
      shareId: "",
    }

    window.cb = this
  }

  componentDidMount() {
    // 解决二次分享问题
    removeWechatPostfix()

    // 炼金术分享
    const shareId = getKey("shareId")
    if (shareId) {
      this.setState({ shareId })
    }

    //长城长分享
    const userId = getKey("userId")
    sessionStorage.setItem("userId", userId)

    //神策
    initSensors(userId)

    // app内外微信分享注册
    wechatShare()
  }

  handleClick() {
    trackEvent("立即开宝箱")
    login(this.state.shareId)
  }
  changeRulesModal() {
    this.setState({ showRulesModal: !this.state.showRulesModal })
  }

  //登陆后回调函数
  loginSuccess() {
    if (this.state.shareId) {
      this.props.history.push(`/mystatus/?shareId=${this.state.shareId}`)
    } else {
      this.props.history.push(`/mystatus/`)
    }
  }

  render() {
    return (
      <Fragment>
        <div className={styles.container}>
          <div className={styles.head}>
            <div className={styles.bgWrap}>
              <picture>
                <source
                  srcSet="https://fintechapp-prd-1258285289.file.myqcloud.com/static_files/dig-treasure/homeBg.webp"
                  type="image/webp"
                />
                <img
                  src=" https://fintechapp-prd-1258285289.file.myqcloud.com/static_files/dig-treasure/homeBg.png"
                  alt="bg"
                />
              </picture>
            </div>

            <div>
              <div className={styles.roundsBar}>
                <picture>
                  <source
                    srcSet="https://fintechapp-prd-1258285289.file.myqcloud.com/static_files/dig-treasure/roundsBar.webp"
                    type="image/webp"
                  />
                  <img
                    src="https://fintechapp-prd-1258285289.file.myqcloud.com/static_files/dig-treasure/roundsBar.png"
                    alt="rounds"
                  />
                </picture>
              </div>
              <div
                className={styles.aboutActivity}
                onClick={() => this.changeRulesModal()}
              >
                <img
                  src="https://fintechapp-prd-1258285289.file.myqcloud.com/static_files/dig-treasure/aboutActivity.png"
                  alt="about activity"
                />
              </div>
              <div className={styles.startTime}>活动开始时间 2020年4月15日</div>
              <div className={styles.promotionBar}>
                <img
                  src="https://fintechapp-prd-1258285289.file.myqcloud.com/static_files/dig-treasure/promotionBar.png"
                  alt="promotionbar"
                />
              </div>
              <div className={styles.invite}>
                <div className={styles.first}>邀请好友助力</div>
                <div className={styles.second}>
                  获得幸运值，100元京东卡等你来拿！
                </div>
              </div>
              <div className={styles.btn}>
                <Button
                  title="立即开宝箱"
                  onClick={() => this.handleClick()}
                  size="lg"
                />
              </div>
            </div>
          </div>

          <div className={styles.secondPart}>
            <div className={styles.prizes}>
              <picture>
                <source
                  srcSet="https://fintechapp-prd-1258285289.file.myqcloud.com/static_files/dig-treasure/prizes.webp"
                  type="image/webp"
                />
                <img
                  src="https://fintechapp-prd-1258285289.file.myqcloud.com/static_files/dig-treasure/prizes.png"
                  alt="rounds"
                />
              </picture>
            </div>
            <div className={styles.rulesOne}>
              <picture>
                <source
                  srcSet="https://fintechapp-prd-1258285289.file.myqcloud.com/static_files/dig-treasure/rulesOne.webp"
                  type="image/webp"
                />
                <img
                  src="https://fintechapp-prd-1258285289.file.myqcloud.com/static_files/dig-treasure/rulesOne.png"
                  alt="rounds"
                />
              </picture>
            </div>
            <div className={styles.rulesTwo}>
              <picture>
                <source
                  srcSet="https://fintechapp-prd-1258285289.file.myqcloud.com/static_files/dig-treasure/rulesTwo.webp"
                  type="image/webp"
                />
                <img
                  src="https://fintechapp-prd-1258285289.file.myqcloud.com/static_files/dig-treasure/rulesTwo.png"
                  alt="rounds"
                />
              </picture>
            </div>
            <div className={styles.statement}>
              <h1>其他细则说明</h1>
              <p>1.活动奖品可在“我的”页面——活动奖品中查看。</p>
              <p>
                2.严禁通过漏洞恶意套取奖励，或通过内部消息取得不当利益，违者将追回奖励并追究法律责任。
              </p>
              <p>3.以上活动内部员工禁止参与兑奖。</p>
              <p>
                4.兑换奖励者需已在长城证券开通资金账号，一个资金账号仅可参与一次兑奖。
              </p>
              <p>5.本活动最终解释权归长城证券所有。</p>
              {isIOS && <p>6.本活动与App Inc.无关。</p>}
            </div>

            <footer>长城证券客服热线 95514</footer>
          </div>
        </div>
        {this.state.showRulesModal && (
          <RulesModal toggleModal={() => this.changeRulesModal()} />
        )}
      </Fragment>
    )
  }
}

export default Home
